import { Flex, Hide, Show } from "@chakra-ui/react"
import { TechnicalAttributesModel } from "../../../../../api-clients/product-api-v1/api"
import { sectionColumnBreakpoints } from "../../../../../common/constants/pdp-constants"
import { useBrandedTranslation } from "../../../../../common/hooks/useBrandedTranslation"
import { determineNumberOfRows } from "../../../../../common/utils/pdp-utils"
import { SectionTitle } from "../../../../shared/SectionTitle"
import SimpleTableColumn from "../../../../shared/SimpleTableColumn"

type Props = {
  technicalDataList: TechnicalAttributesModel[]
}

const TechnicalData = ({ technicalDataList }: Props) => {
  const { t } = useBrandedTranslation()
  const technicalDataListNumberOfRows = determineNumberOfRows(technicalDataList.length)

  return (
    <>
      <SectionTitle title={t("pdp-nav-technicalData")} mb="6" />

      <Show above="md">
        <Flex gap="6">
          <SimpleTableColumn tableData={technicalDataList.slice(0, technicalDataListNumberOfRows)} />

          {technicalDataList.length > sectionColumnBreakpoints.FIRST_BREAKPOINT && (
            <SimpleTableColumn tableData={technicalDataList.slice(technicalDataListNumberOfRows)} />
          )}
        </Flex>
      </Show>

      <Hide above="md">
        <SimpleTableColumn tableData={technicalDataList} />
      </Hide>
    </>
  )
}

export default TechnicalData
